<template>
  <div class="app-wrapper templateOne">
    <nav-bar></nav-bar>
    <div class="main-container">
      <div class="mainBanner">
        <div class="layoutMain">
          <div class="bread">
            <span style="font-size:15px;font-weight:600" @click="goHomes()"
              >JAVA学科</span
            >
            >
            <span>探花交友</span>
          </div>
          <div class="bannerCon">
            <div class="bannerTip"></div>
            <div class="bannerInfo">
              学员可通过该项目掌握社交、即时通讯等主流架构的解决方案。在实践中解决海量数据存储问题，不断强化同类问题的解决能力。此外，学员还可通过该项目学习当下主流的Spark+MLlib技术，该技术在提高信息推送准确度的同时极大提升了用户体验。学习完成后，学员将成为移动社交领域熟谙业务和技术的中级java开发人员。
            </div>
          </div>
        </div>
      </div>
      <div class="layoutMain">
        <!-- banner -->
        <div class="mainBox">
          <div class="industryInfo">
            <div class="industTop"></div>
            <div class="industBottom"></div>
            <ul class="industryList clear">
              <li>
                <p class="fontsize">社交</p>
                <p>所属行业</p>
              </li>
              <li>
                <p class="fontsize">
                  16
                  <em>个</em>
                </p>
                <p>业务功能</p>
              </li>
              <li>
                <p class="fontsize">
                  50
                  <em>个</em>
                </p>
                <p>页面数量</p>
              </li>
              <li>
                <p class="fontsize">
                  28
                  <em>个</em>
                </p>
                <p>解决方案</p>
              </li>
              <li>
                <p class="fontsize">
                  8
                  <em>个</em>
                </p>
                <p>课程天数</p>
              </li>
            </ul>
            <div class="temVideo"><em></em>分钟了解探花交友</div>
          </div>
        </div>
        <!-- end -->
        <!--  -->
        <div class="mainBox">
          <div class="temTab">
            <el-tabs v-model="activeTab">
              <el-tab-pane label name="first">
                <span slot="label">APP演示</span>
                <div class="tabCon conBoxModel">
                  <div class="foodCon">
                    <viewer
                      :images="modelData.pAdImages"
                      class="imgVideo appScroll"
                      v-if="
                        this.pVideoUrlData.length !== 0 ||
                          modelData.pAdImages.length !== 0
                      "
                    >
                      <swiper :options="swiperOption">
                        <template v-if="modelData.pAdImages.length !== 0">
                          <swiper-slide
                            class="1"
                            id="index"
                            style="width:316px !important;height:630 !important"
                          >
                            <div class="imgBg">
                              <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                              <img
                                src="./../../../assets/likede/likedes/i1.png"
                                class="imgPosition"
                              />
                            </div>
                          </swiper-slide>
                          <swiper-slide
                            class="1"
                            id="index"
                            style="width:316px !important;height:630 !important"
                          >
                            <div class="imgBg">
                              <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                              <img
                                src="./../../../assets/likede/likedes/i2.png"
                                class="imgPosition"
                              />
                            </div>
                          </swiper-slide>
                          <swiper-slide
                            class="1"
                            id="index"
                            style="width:316px !important;height:630 !important"
                          >
                            <div class="imgBg">
                              <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                              <img
                                src="./../../../assets/likede/likedes/i3.png"
                                class="imgPosition"
                              />
                            </div>
                          </swiper-slide>
                          <swiper-slide
                            class="1"
                            id="index"
                            style="width:316px !important;height:630 !important"
                          >
                            <div class="imgBg">
                              <!-- <img v-lazy="{src: item.url,loading:require('./../../../../assets/wheelplanting.jpg')}" class="imgPosition" /> -->
                              <img
                                src="./../../../assets/likede/likedes/i4.png"
                                class="imgPosition"
                              />
                            </div>
                          </swiper-slide>
                        </template>
                        <template
                          v-if="
                            this.pVideoUrlData.length !== 0 ||
                              modelData.pAdImages.length !== 0
                          "
                        >
                          <div
                            class="swiper-pagination"
                            slot="pagination"
                          ></div>
                          <div class="swiper-button-prev" slot="button-prev">
                            <div class="card-carousel--nav__left"></div>
                          </div>
                          <div class="swiper-button-next" slot="button-next">
                            <div class="card-carousel--nav__right"></div>
                          </div>
                        </template>
                      </swiper>
                    </viewer>
                  </div>
                  <div class="conBtn">
                    <a>查看前台演示</a>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!-- end  -->
      </div>
      <!--  -->
      <div class="studyBox">
        <div class="layoutMain">
          <h2 class="tit">如果您是他们中的一员，可随时开启学习之路</h2>
          <div class="studyMain">
            <ul>
              <li>
                <div class="iconbg icon1"></div>
                <p class="fchild">在校大学生</p>
                <p>
                  想进入IT行业
                  <br />想提前学习技术 <br />想有更高的职场起点
                </p>
              </li>
              <li>
                <div class="iconbg icon2"></div>
                <p class="fchild">想强化技能的职场人士</p>
                <p>
                  想在移动社交领域深入发展
                  <br />想了解更多样的业务场景 <br />想突破职业瓶颈
                </p>
              </li>
              <li>
                <div class="iconbg icon3"></div>
                <p class="fchild">职场小白</p>
                <p>
                  想选择更有前景的行业
                  <br />想学习更有潜力的技术 <br />想飞速升高自身本领
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- end -->
      <!--  -->
      <div
        class="layoutMain"
        style="margin-top:-40px;position: relative;z-index: 1;"
      >
        <div class="mainBox radius">
          <div class="exhibition">
            <div class="titTextInfo">
              <h2>移动社交领域主流业务功能全覆盖</h2>
              <p>与市场主流移动社交产品功能完全同步，所学即所用</p>
            </div>
            <div class="picInfo">
              <img src="../../../assets/template1/img1.jpg" />
            </div>
            <div class="titTextInfo">
              <h2>移动社交领域超前沿技术无遗漏</h2>
              <p>大厂技术专家，历时6个月打造紧跟市场趋势的技术架构</p>
            </div>
            <div class="picInfo">
              <img src="../../../assets/template1/img2.jpg" />
            </div>
            <div class="itemLists">
              <ul>
                <li><em></em>采用 Elasticsearch Geo实现地理位置查询。</li>
                <li><em></em>采用 RocketMQ 作为消息服务中间件。</li>
                <li><em></em>采用 MongoDB 进行海量数据的存储。</li>
                <li><em></em>采用 Spark + Mllib 实现智能推荐。</li>
                <li><em></em>采用环信服务实现即时通讯。</li>
                <li><em></em>采用分布式文件系统存储小视频数据。</li>
                <li><em></em>用户支付采用支付宝扫码等常用支付方式。</li>
                <li><em></em>采用 Apache Dobbo 作为微服务架构技术。</li>
                <li><em></em>采用 Spring Boot + Mybatis 实现系统主架构。</li>
                <li><em></em>采用 Redis 集群实现缓存的高可用。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <!--  -->
      <div class="studyBox" style="margin-top:-40px">
        <div class="layoutMain">
          <h2 class="tit info">
            跨行业移动社交整合性
            <em>解决方案</em>拓宽学员知识面
          </h2>
          <p class="textTip">
            凡有移动社交技术需求的地方，就有传智学员大展拳脚的空间
          </p>
          <div class="programme">
            <div class="itemLists">
              <ul>
                <li><em></em>采用 Elasticsearch Geo实现地理位置查询。</li>
                <li><em></em>采用 RocketMQ 作为消息服务中间件。</li>
                <li><em></em>采用 MongoDB 进行海量数据的存储。</li>
                <li><em></em>采用 Spark + Mllib 实现智能推荐。</li>
                <li><em></em>采用环信服务实现即时通讯。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <!--  -->
      <div class="studyRouteBox">
        <div class="layoutMain">
          <div class="studyRoute">
            <h2>
              由简入繁，节奏适中
              <br />丰富经验沉淀为符合知识吸收规律的学习路线
            </h2>
            <div class="outlineBox">
              <el-tabs :tab-position="tabPosition" style="height: 600px;">
                <el-tab-pane
                  label
                  v-for="(item, index) in courseOutData"
                  :key="index"
                >
                  <div slot="label" class="outlineTitle">
                    <p>
                      {{ getCaptionReg(item.titles) }}({{
                        getCaption(item.titles)
                      }})
                    </p>
                    <span>{{ getCaption2(item.titles) }}</span>
                  </div>
                  <div class="outlineeInfo">
                    <div v-for="(val, num) in item.desc" :key="num">
                      <em class="courseOutTitle">{{ val.title }}</em>
                      <ul class="courseOutList">
                        <li
                          v-for="(v, n) in val.conten.split(/\↵|\r|\n|\r\n/)"
                          :key="n"
                        >
                          {{ v }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="studyBtn" style="bottom:-30px">
              <a>马上学习</a>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <!--  -->
      <div class="roadJava">
        <div class="layoutMain">
          <div class="roadMain">
            <h2>
              由简入繁，节奏适中
              <br />丰富经验沉淀为符合知识吸收规律的学习路线
            </h2>
            <div class="roadCon">
              <ul>
                <li>
                  <p>
                    <span class="headPic">
                      <img src="../../../assets/template1/pic2.png" />
                    </span>
                  </p>
                  <p class="fontSize">
                    张志军
                    <br />架构师
                  </p>
                  <p>
                    Java企业级应用专家、WEB技术专家，中科院软件工程硕士。07年起曾主持研发过多套软件培训课程与教材，精通JAVAEE、PHP、RUBY、JavaSCRIPT、RIA等多种主流开发语言，曾主持参与过中国联通UMMS二期工程等多个大项目。
                  </p>
                </li>
                <li>
                  <p>
                    <span class="headPic">
                      <img src="../../../assets/template1/pic2.png" />
                    </span>
                  </p>
                  <p class="fontSize">
                    张志军
                    <br />架构师
                  </p>
                  <p>
                    Java企业级应用专家、WEB技术专家，中科院软件工程硕士。07年起曾主持研发过多套软件培训课程与教材，精通JAVAEE、PHP、RUBY、JavaSCRIPT、RIA等多种主流开发语言，曾主持参与过中国联通UMMS二期工程等多个大项目。
                  </p>
                </li>
                <li>
                  <p>
                    <span class="headPic">
                      <img src="../../../assets/template1/pic2.png" />
                    </span>
                  </p>
                  <p class="fontSize">
                    张志军
                    <br />架构师
                  </p>
                  <p>
                    Java企业级应用专家、WEB技术专家，中科院软件工程硕士。07年起曾主持研发过多套软件培训课程与教材，精通JAVAEE、PHP、RUBY、JavaSCRIPT、RIA等多种主流开发语言，曾主持参与过中国联通UMMS二期工程等多个大项目。
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <MenuAdd ref="editMenu"></MenuAdd>
      <div class="down">
        <div class="city">
          江苏传智播客教育科技股份有限公司 版权所有Copyright 2006-2022 All
          Rights Reserved 苏ICP备16007882号营业执照增值电信业务经营许可证
        </div>
      </div>
      <!-- <div class="temFoot">
        <div class="layoutMain">
          <div class="foot">
            <img src="../../../assets/logo6.png" />
          </div>
        </div>
      </div>-->
    </div>
    <!-- <span class="topClass" @click="goTop"></span> -->
  </div>
</template>

<script>
// import layoutNavbar from './../../components/templateNavbar'
import MenuAdd from "./../../components/video";
import navBar from "./../../components/navBar";
import baseApi from "@/base/baseApi";
import { Content } from "../../../gqlapi/ContentDetail.js";
export default {
  name: "layout",
  components: {
    navBar,
    MenuAdd,
    // layoutNavbar
  },
  data() {
    return {
      activeTab: "first",
      tabPosition: "left",
      currents: -1,
      activeIndex: -1,
      isSelected: "navon0-selected",
      activeName: "1",
      active: "1",
      detailId: "",
      menuData: [],
      baseData: {},
      demoLink: [],
      baseInfo: [],
      courseOutData: [],
      highlightsData: [],
      solutionData: [],
      currentOffset: 0,
      windowSize: 0,
      paginationFactor: 235,
      functionaUrl: "",
      technicalUrl: "",
      testImage: "",
      productArchitectureUrl: "",
      productStructureUrl: "",
      projectSummaryUrl: "",
      modelData: {
        name: "",
        tradename: "",
        platforms: "",
        lastUpdate: "",
        description: "",
        pVideoUrl: "",
        videologoImage: "",
        pAdImages: "",
        logoImage: "",
        version: "",
      },
      pVideoUrlData: [],
      listHeight: [],
      currentIndex: 0,
      distance: 0,
      total: 0,
      step: 0,
      seen: false,
      current: 0,
      swiperOption: {
        slidesPerView: "auto",

        spaceBetween: 15,
        slidesPerGroup: 3,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      projectToolsl: [],
    };
  },
  watch: {
    $route() {
      this.getData(6);
    },
  },

  created() {
    this.menuData = baseApi.menuList;
    this.detailId = this.$route.query.id;
    this.getData(6);
    this.activeName = this.$route.query.tab;
    this.$nextTick(() => {
      this._initScroll();
      setTimeout(() => {
        this._calculateHeight();
        //document.body.scrollTop = 0;
        //document.documentElement.scrollTop = 0;
      }, 3000);
    });
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.modelData.pAdImages.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    handleVideo(url, e) {
      console.log(e);
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(url);
    },
    // 获取详情
    getData(detailId) {
      this.$axios
        .post("/api", {
          operationName: "Content",
          variables: {
            id: detailId,
          },
          query: Content,
        })
        .then((res) => {
          this.baseData = res.data.data;

          //项目情况
          this.modelData.name = this.baseData.pContent.name;
          this.modelData.version = this.baseData.pContent.version;
          if (this.baseData.pContent.trade !== null) {
            this.modelData.tradename = this.baseData.pContent.trade.name;
          } else {
            this.modelData.tradename = null;
          }

          this.modelData.platforms = this.baseData.pContent.platforms;
          this.modelData.lastUpdate = this.baseData.pContent.lastUpdate;
          this.modelData.description = this.baseData.pContent.description;
          this.modelData.pVideoUrl = this.baseData.pContent.pVideoUrl;

          this.modelData.pAdImages = this.baseData.pContent.pAdImages;

          this.modelData.testImage = this.baseData.pContent.testArchitectureImage;

          if (this.baseData.pContent.videoLogoImage === null) {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage;
          } else {
            this.modelData.videologoImage = this.baseData.pContent.videoLogoImage.url;
          }
          var pvideoData = [];
          if (this.modelData.pVideoUrl !== null) {
            var pvideo = {
              videoUrl: this.modelData.pVideoUrl,
              videoLogoImage: this.modelData.videologoImage,
            };
            pvideoData.push(pvideo);
            this.pVideoUrlData = pvideoData;
          } else {
            this.pVideoUrlData.length = 0;
          }
          //项目logo
          if (this.baseData.pContent.detailLogoImage === null) {
            debugger;
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage;
          } else {
            this.modelData.logoImage = this.baseData.pContent.detailLogoImage.url;
          }
          //测试框架图
          if (this.baseData.pContent.testArchitectureImage === null) {
            this.testImage = this.baseData.pContent.testArchitectureImage;
          } else {
            this.testImage = this.baseData.pContent.testArchitectureImage.url;
          }
          //功能架构图
          if (this.baseData.pContent.functionalArchitectureDiagram === null) {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram;
          } else {
            this.functionaUrl = this.baseData.pContent.functionalArchitectureDiagram.url;
          }
          //技术架构图
          if (this.baseData.pContent.technicalArchitectureDiagram === null) {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram;
          } else {
            this.technicalUrl = this.baseData.pContent.technicalArchitectureDiagram.url;
          }

          //产品架构图
          if (this.baseData.pContent.productArchitectureDiagramImage === null) {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage;
          } else {
            this.productArchitectureUrl = this.baseData.pContent.productArchitectureDiagramImage.url;
          }

          //产品结构图
          if (this.baseData.pContent.productStructureImage === null) {
            this.productStructureUrl = this.baseData.pContent.productStructureImage;
          } else {
            this.productStructureUrl = this.baseData.pContent.productStructureImage.url;
          }

          //项目总结
          if (this.baseData.pContent.projectSummaryImage === null) {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage;
          } else {
            this.projectSummaryUrl = this.baseData.pContent.projectSummaryImage.url;
          }

          //所有软件
          if (this.baseData.pContent.tools.length > 0) {
            this.projectToolsl = this.baseData.pContent.tools;
            console.log(this.projectToolsl);
          }

          //演示地址
          var dataLink = [
            this.baseData.pContent.demoLink1,
            this.baseData.pContent.demoLink2,
            this.baseData.pContent.demoLink3,
            this.baseData.pContent.demoLink4,
            this.baseData.pContent.demoLink5,
            this.baseData.pContent.demoLink6,
          ];
          var data = [];

          for (var i = 0; i < dataLink.length; i++) {
            if (dataLink[i] !== "标题|链接|说明" && dataLink[i] !== "") {
              data = dataLink[i].split("|");
              this.demoLink.push(data);
            }
          }
          var userObj = {};
          var userData = [];
          for (var n = 0; n < this.demoLink.length; n++) {
            var twoUrl = "";
            var imgReg = ["jpg", "png", "gif"];
            var index = this.demoLink[n][1].lastIndexOf(".");
            var ext = this.demoLink[n][1].substr(index + 1);
            for (var t = 0; t < imgReg.length; t++) {
              if (ext.replace(/\s+/g, "") === imgReg[t]) {
                twoUrl = this.demoLink[n][1];
              }
            }

            if (this.demoLink[n][2] !== undefined) {
              this.demoLink[n][2] = this.demoLink[n][2].split(" ");
              userObj = {
                name: this.demoLink[n][0],
                url: this.demoLink[n][1],
                twoUrl: "",
                conten: this.demoLink[n][2],
              };
            } else {
              userObj = {
                name: this.demoLink[n][0],
                url: this.demoLink[n][1],
                twoUrl: twoUrl,
                conten: [],
              };
            }

            userData.push(userObj);
          }
          this.demoLink = userData;
          //基本信息
          var baseInfoTitle = [
            this.baseData.pContent.baseInfoTitle1,
            this.baseData.pContent.baseInfoTitle2,
            this.baseData.pContent.baseInfoTitle3,
            this.baseData.pContent.baseInfoTitle4,
            this.baseData.pContent.baseInfoTitle5,
            this.baseData.pContent.baseInfoTitle6,
            this.baseData.pContent.baseInfoTitle7,
            this.baseData.pContent.baseInfoTitle8,
          ];
          var baseInfoDesc = [
            this.baseData.pContent.baseInfoDesc1,
            this.baseData.pContent.baseInfoDesc2,
            this.baseData.pContent.baseInfoDesc3,
            this.baseData.pContent.baseInfoDesc4,
            this.baseData.pContent.baseInfoDesc5,
            this.baseData.pContent.baseInfoDesc6,
            this.baseData.pContent.baseInfoDesc7,
            this.baseData.pContent.baseInfoDesc8,
          ];
          this.infoData(baseInfoTitle, baseInfoDesc, this.baseInfo, "base");
          //技术亮点
          var highlightsData;
          if (this.baseData.pContent.technicalHighlights !== null) {
            highlightsData = this.baseData.pContent.technicalHighlights.split(
              /↵|\n/
            );
            this.forData(highlightsData, this.highlightsData);
          } else {
            this.highlightsData.length = 0;
          }

          //解决方案
          var soluData;
          if (this.baseData.pContent.technologySolution !== null) {
            soluData = this.baseData.pContent.technologySolution.split(/↵|\n/);
            this.forData(soluData, this.solutionData);
          } else {
            this.solutionData.length = 0;
          }
          //课程大纲
          var courseOutlineTitle = [
            this.baseData.pContent.courseOutlineTitle1,
            this.baseData.pContent.courseOutlineTitle2,
            this.baseData.pContent.courseOutlineTitle3,
            this.baseData.pContent.courseOutlineTitle4,
            this.baseData.pContent.courseOutlineTitle5,
            this.baseData.pContent.courseOutlineTitle6,
            this.baseData.pContent.courseOutlineTitle7,
            this.baseData.pContent.courseOutlineTitle8,
            this.baseData.pContent.courseOutlineTitle9,
            this.baseData.pContent.courseOutlineTitle10,
            this.baseData.pContent.courseOutlineTitle11,
            this.baseData.pContent.courseOutlineTitle12,
            this.baseData.pContent.courseOutlineTitle13,
            this.baseData.pContent.courseOutlineTitle14,
            this.baseData.pContent.courseOutlineTitle15,
            this.baseData.pContent.courseOutlineTitle16,
            this.baseData.pContent.courseOutlineTitle17,
            this.baseData.pContent.courseOutlineTitle18,
            this.baseData.pContent.courseOutlineTitle19,
            this.baseData.pContent.courseOutlineTitle20,
          ];
          var courseOutlineDesc = [
            this.baseData.pContent.courseOutlineDesc1,
            this.baseData.pContent.courseOutlineDesc2,
            this.baseData.pContent.courseOutlineDesc3,
            this.baseData.pContent.courseOutlineDesc4,
            this.baseData.pContent.courseOutlineDesc5,
            this.baseData.pContent.courseOutlineDesc6,
            this.baseData.pContent.courseOutlineDesc7,
            this.baseData.pContent.courseOutlineDesc8,
            this.baseData.pContent.courseOutlineDesc9,
            this.baseData.pContent.courseOutlineDesc10,
            this.baseData.pContent.courseOutlineDesc11,
            this.baseData.pContent.courseOutlineDesc12,
            this.baseData.pContent.courseOutlineDesc13,
            this.baseData.pContent.courseOutlineDesc14,
            this.baseData.pContent.courseOutlineDesc15,
            this.baseData.pContent.courseOutlineDesc16,
            this.baseData.pContent.courseOutlineDesc17,
            this.baseData.pContent.courseOutlineDesc18,
            this.baseData.pContent.courseOutlineDesc19,
            this.baseData.pContent.courseOutlineDesc20,
          ];
          this.infoData(
            courseOutlineTitle,
            courseOutlineDesc,
            this.courseOutData,
            "out"
          );

          var couseOutBase = {};
          var courseOutData = [];
          // 后端数据处理
          this.courseOutData.forEach(function(item) {
            if (item.desc !== null && item.desc !== "") {
              var items = item.desc.split(/;|；/);
              var descData = items.map((val) => {
                var arr = val.split("：");
                return { title: arr[0], conten: arr[1] };
              });
              couseOutBase = {
                titles: item.title
                  .replace(/\[.*?\]/g, "")
                  .replace(/\(.*?\)/g, ""),
                desc: descData,
                video: item.video,
              };
              courseOutData.push(couseOutBase);
            }
          });
          this.courseOutData = courseOutData;
          console.log(852369, this.courseOutData);
          if (this.demoLink.length === 0) {
            this.$refs.div1.style.display = "none";
          }
          if (this.baseInfo.length === 0) {
            this.$refs.div2.style.display = "none";
          }
          if (this.highlightsData.length === 0) {
            this.$refs.div3.style.display = "none";
          }

          if (this.testImage == null) {
            this.$refs.div4.style.display = "none";
          }

          if (this.solutionData.length === 0) {
            this.$refs.div5.style.display = "none";
          }

          if (this.functionaUrl == null) {
            this.$refs.div6.style.display = "none";
          }
          if (this.technicalUrl == null) {
            this.$refs.div7.style.display = "none";
          }
          if (this.productArchitectureUrl == null) {
            this.$refs.div8.style.display = "none";
          }

          if (this.productStructureUrl == null) {
            this.$refs.div9.style.display = "none";
          }
          if (this.courseOutData.length === 0) {
            this.$refs.div10.style.display = "none";
          }
          if (this.projectSummaryUrl == null) {
            this.$refs.div0.style.display = "none";
          }
          if (this.projectToolsl.length === 0) {
            this.$refs.div01.style.display = "none";
          }
        })
        .catch((err) => {
          console.log(999, err);
        });
    },
    getCaption(obj) {
      if (obj.lastIndexOf("（") > 0) {
        obj = obj.substring(obj.indexOf("（") + 1, obj.indexOf("）"));
        return obj;
      }
    },
    getCaption2(obj) {
      if (obj.lastIndexOf("（") > 0) {
        obj = obj.substring(obj.indexOf("：") + 1, obj.indexOf("（"));
        return obj;
      }
    },
    getCaptionReg(obj) {
      obj = obj.split("：")[0];
      return obj;
    },
    infoData(title, desc, items, name) {
      var obj = {};
      for (var f = 0; f < title.length; f++) {
        for (var d = 0; d < desc.length; d++) {
          if (f === d) {
            if (title[f] !== null && title[f] !== "") {
              if (name === "base") {
                var baseInfo = desc[d];
                if (desc[d] !== null && desc[d] !== "") {
                  baseInfo = desc[d].split("\n");
                } else {
                  baseInfo = desc[d];
                }
                obj = {
                  title: title[f],
                  desc: baseInfo,
                };
              } else {
                var videoName = title[f].lastIndexOf("[");
                var videoUrl = title[f].lastIndexOf("(");

                var names = "";
                var urls = "";
                if (videoName > 0) {
                  names = title[f].substring(
                    title[f].indexOf("[") + 1,
                    title[f].indexOf("]")
                  );
                }
                if (videoUrl > 0) {
                  urls = title[f].substring(
                    title[f].indexOf("(") + 1,
                    title[f].indexOf(")")
                  );
                }
                var videoObj = {};

                videoObj = {
                  name: names,
                  url: urls,
                };
                obj = {
                  title: title[f],
                  desc: desc[d],
                  video: videoObj,
                };
                console.log(obj.video.name, obj.video.url);
              }
              items.push(obj);
            }
          }
        }
      }
    },
    forData(data, items) {
      for (var i = 0; i < data.length; i++) {
        if (data[i] !== "") {
          items.push(data[i]);
        }
      }
    },
    selectMenu(index, event) {
      console.log(event);
      /*if(event._constructed){
        return
      }*/

      this.distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      let jump = this.$refs.rightContent.getElementsByClassName(
        "food-list-hook"
      );
      let total = jump[index].offsetTop; // 获取需要滚动的距离
      this.total = total + 100;
      // Chrome
      document.body.scrollTop = this.total;
      // Firefox
      document.documentElement.scrollTop = this.total;
      // Safari
      window.pageYOffset = this.total;
      this.currentIndex = index;
      this.step = this.total / 50;
      if (this.total > this.distance) {
        this.smoothDown();
      } else {
        let newTotal = this.distance - this.total;
        this.step = newTotal / 50;
        this.smoothUp();
      }
    },
    _initScroll() {},
    scrool(pos) {
      console.log(pos);
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      for (var i = 0; i < this.listHeight.length; i++) {
        if (
          this.listHeight[i] < scrolled + 180 &&
          scrolled + 180 < this.listHeight[i + 1]
        ) {
          this.currentIndex = i;
          return false;
        }
      }
    },
    smoothDown() {
      if (this.distance < this.total) {
        this.distance += this.step;
        document.documentElement.scrollTop = this.distance;
        setTimeout(this.smoothDown, 10);
      } else {
        document.body.scrollTop = this.total - 80;
        document.documentElement.scrollTop = this.total - 80;
      }
    },
    smoothUp() {
      if (this.distance > this.total) {
        this.distance -= this.step;
        document.documentElement.scrollTop = this.distance;
        setTimeout(this.smoothUp, 10);
      } else {
        document.body.scrollTop = this.total - 80;
        document.documentElement.scrollTop = this.total - 80;
      }
    },
    _calculateHeight() {
      if (this.$refs.rightContent !== undefined) {
        let foodList = this.$refs.rightContent.getElementsByClassName(
          "food-list-hook"
        );
        let height = 0;
        this.listHeight.push(height);
        for (let i = 0; i < foodList.length; i++) {
          let item = foodList[i];
          height += item.clientHeight;
          this.listHeight.push(height);
        }
      }
    },
    enter(index) {
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    setIndex(index) {
      if (this.activeIndex === index) {
        this.currents = -1;
        this.activeIndex = -1; //在这里就将它赋值为-1  由于：-1 !=  index 所以其他内容隐藏 ，被点击的则打开
      } else {
        this.activeIndex = index; //这里是把index赋值给isShow，isShow=index则显示
        this.currents = index;
      }
    },

    handleLink(link, e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      window.open(link.video.url, "_self");
    },
    goTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
  //mounted() {
  //    var self = this;
  //    var liIds = [];
  //    var lis =this.menuData;
  //    for (var i = 0; i < lis.length; i++) {
  //      liIds.push('navon'+i);
  //    }
  //    var $scrollBox = document.querySelector('.container');

  //    var scrollCallback = self.debounce(function () {
  //      var top = $scrollBox.scrollTop; //设置变量top,表示当前滚动条到顶部的值
  //      var tt = $scrollBox.clientHeight; //设置变量tt,表示当前滚动窗口高度的值
  //      var num = 0;
  //      for (var n = 0; n < 7; n++) {
  ////在此处通过判断滚动条到顶部的值和当前窗口高度的关系
  ////（当前窗口的n倍 <= top <= 当前窗口的n+1倍）来取得和导航索引值的对应关系
  //        if (top >= n * tt && top <= (n + 1) * tt) {
  //          num = n;
  //        }
  //        self.isSelected = liIds[num] + '-selected';
  //      }

  //    }, 100)
  //    $scrollBox.addEventListener('scroll', scrollCallback)

  //  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.bottom {
  p {
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
.activeClass {
  transform: rotate(90deg);
}
.appScroll {
  .swiper-slide {
    width: 316px;
    height: 630px;
    padding: 10px;
    background: #faf9ff;
    border: 1px solid #ededed;
    border-radius: 30px;
    h2 {
      padding: 35px 0 20px;
      text-align: center;
    }
  }
}
.pcScroll {
  .swiper-slide {
    width: 337px;
    height: 307px;
  }
}
.swiper-slide-invisible-blank {
  display: none;
}
.conBoxModel .appScroll .imgPosition {
  width: 276px;
  height: 508px;
  border-radius: 30px;
}
.imgBg {
  width: 316px;
  height: 630px;
  background: #fff;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 10px;
}
.bread {
  position: absolute;
  top: 100px;
  right: 315px;
  color: white;
  cursor: pointer;
}
</style>
